import angular from 'angular';
import BrandsComponent from './brands.component';

let BrandsModule = angular.module('home.brands', [])
  .component('brands', BrandsComponent);

export default BrandsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/home/brands/brands.js
 **/